import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    textTransform: 'uppercase',

    '&.MuiTypography-root': {
      letterSpacing: '0.15em',
      fontWeight: 'bold',
      fontSize: theme.spacing(1.5),
    },
  },
}));
